import React from "react";
import { Button, Popover } from "antd";
import {
  ArrowRightOutlined,
  DeleteOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { getSheetLinkLabel } from "../utils";

const SheetLinkPopover = ({
  annotation,
  anchor,
  canDelete = true,
  onClose,
  onGoTo,
  onChangeTarget,
  onDelete,
}) => {
  if (!annotation || !anchor) return null;

  const drawingNumber = (
    annotation.targetDrawingCode ||
    annotation.targetDrawingNumber ||
    "Sheet"
  ).replace(/^(.*\d)\.\d{1,3}$/, "$1");
  const isResolved = !!annotation.targetDrawingId;

  return (
    <Popover
      open
      trigger="click"
      placement="bottom"
      title={getSheetLinkLabel(annotation)}
      onOpenChange={(visible) => {
        if (!visible) onClose();
      }}
      content={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            minWidth: 180,
          }}
        >
          <Button
            type="primary"
            icon={<ArrowRightOutlined />}
            disabled={!isResolved}
            onClick={onGoTo}
            block
          >
            Go to {drawingNumber}
          </Button>
          {!isResolved && (
            <span style={{ color: "#8c8c8c", fontSize: 12 }}>
              Not found in this folder
            </span>
          )}
          <Button icon={<LinkOutlined />} onClick={onChangeTarget} block>
            Change target
          </Button>
          <Button
            danger
            icon={<DeleteOutlined />}
            disabled={!canDelete}
            title={
              canDelete ? undefined : "Consultants cannot delete saved annotations"
            }
            onClick={onDelete}
            block
          >
            Delete
          </Button>
        </div>
      }
    >
      <div
        style={{
          position: "absolute",
          left: anchor.left,
          top: anchor.top,
          width: anchor.size,
          height: anchor.size,
          pointerEvents: "none",
        }}
      />
    </Popover>
  );
};

export default SheetLinkPopover;
